<template>
  <div class="home" style="background: #eee; padding-top: 35px">
    <Header title="任务大厅" :hideBack="true" />
    <!--筛选条件-->
    <div
      style="
        border-bottom: 1px solid #eee;
        margin: 0 auto;
        margin-top: 10px;
        background: #eee;
        width: 92%;
      "
    >
      <el-row type="flex" align="middle" style="height: 40px">
        <el-col :span="8">
          <el-select
            v-model="search.state"
            placeholder="请选择"
            @change="reSearch"
            size="small"
          >
            <el-option label="全部" value=""> </el-option>
            <el-option
              v-for="o in searchStateList"
              :key="o.id"
              :value="o.id"
              :label="o.text"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="15" :offset="1">
          <el-input
            size="small"
            placeholder="请输入内容搜索"
            class="input-with-select"
            v-model="search.word"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="reSearch"
            ></el-button>
          </el-input>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="10">
          <el-date-picker
            v-model="search.gotime"
            type="date"
            size="small"
            value-format="yyyy-MM-dd"
            style="width: 150px"
            placeholder="选择出发日期"
            @change="reSearch"
          >
          </el-date-picker
        ></el-col>
      </el-row>
    </div>
    <div
      style="
        text-align: right;
        padding-right: 2%;
        font-size: 12px;
        color: #666;
        margin-bottom: -5px;
        margin-top: 6px;
      "
    >
      共计：{{ datacount }}条
    </div>
    <!--数据列表-->
    <div class="datalist">
      <div
        class="item"
        v-for="(item, index) in list"
        v-infinite-scroll="loadNext"
        @click="viewDetail(item, true)"
      >
        <el-row type="flex" align="middle">
          <el-col
            :span="2"
            style="text-align: left"
            v-if="checkRole(4) && item.state == 3"
          >
            <el-checkbox v-model="item.checked"></el-checkbox>
          </el-col>
          <el-col
            :span="checkRole(4) && item.state == 3 ? 18 : 20"
            style="text-align: left"
            ><div @click="viewDetail(item, false)">
              <i class="serno">{{ index + 1 }}</i>
              [{{ item.taskno }}]{{ item.enginner_name }}
            </div></el-col
          >
          <el-col :span="4" style="text-align: right"
            ><el-tag size="small" :type="getStateColor(item.state)">{{
              getStateText(item.state, item.sub_state)
            }}</el-tag></el-col
          >
        </el-row>
        <el-row
          type="flex"
          align="middle"
          style="margin-top: 15px; font-size: 13px"
        >
          <el-col :span="15" style="text-align: left"
            >{{ item.customer }} {{ item.customer_mobile }}</el-col
          >
          <!-- <el-col :span="9" style="text-align: right"
            ><el-rate
              v-model="item.comment_stars"
              disabled
              text-color="#ff9900"
              :score-template="item.comment_stars"
            >
            </el-rate>
          </el-col> -->
        </el-row>
        <el-row
          type="flex"
          align="middle"
          style="
            font-size: 13px;
            border-bottom: 1px solid #eee;
            padding-bottom: 10px;
            margin-top: 5px;
          "
          >{{ item.province + item.city + item.area }} {{ item.address }}
        </el-row>
        <el-row
          type="flex"
          align="middle"
          style="
            margin-top: 5px;
            font-size: 14px;
            background: #f7f7f7;
            margin-bottom: 3px;
          "
          v-for="subitem in item.sublist"
        >
          <el-col :span="16" style="text-align: left"
            ><el-tag style="font-size: 13px; border: 0; background: transparent"
              ><i class="el-icon-user" style="margin-right: 3px">{{
                subitem.groupleader == null
                  ? "待分配"
                  : subitem.groupleader + "(" + subitem.usercount + "人)"
              }}</i></el-tag
            ><el-tag
              style="
                font-size: 13px;
                margin-left: 10px;
                border: 0;
                background: transparent;
              "
              ><i class="el-icon-truck" style="margin-right: 3px"></i
              >{{ subitem.carno == null ? "待分配" : subitem.carno }}</el-tag
            ></el-col
          >
          <el-col :span="8" style="text-align: right; padding-right: 5px">{{
            subitem.gotime
          }}</el-col>
        </el-row>
        <el-row type="flex" align="middle" style="margin-top: 10px">
          <div style="width: 100%; text-align: left; font-size: 13px">
            {{ item.remark }}
          </div>
          <div style="display: flex; justify-content: end">
            <el-button
              size="mini"
              type="primary"
              @click.stop="testTask(item)"
              v-if="checkRole(5) && (item.state == 4 || item.state == 5)"
              >检测</el-button
            >
            <el-button
              size="mini"
              :type="item.state == 3 ? 'primary' : ''"
              @click.stop="passPrivateCar(item.id)"
              v-if="checkRole(2) && item.state == 3 && item.sub_state == 1"
              >私车审批</el-button
            >
            <el-button
              size="mini"
              :type="item.state == 3 ? 'primary' : ''"
              @click.stop="setCarForTask(item.id)"
              v-if="
                checkRole(4) &&
                ((item.state == 3 && item.sub_state != 1) || item.state == 4)
              "
              >派车</el-button
            >
            <el-button
              size="mini"
              :type="item.state == 2 ? 'primary' : ''"
              @click.stop="allocateTask(item.id)"
              v-if="checkRole(3) && (item.state == 2 || item.state == 3)"
              >派人</el-button
            >
            <el-button
              size="mini"
              type="primary"
              @click.stop="showPass(item.id)"
              v-if="checkRole(2) && item.state == 1"
              >审核</el-button
            >


            <!-- <el-button
              size="mini"
              type="primary"
              @click.stop="showDevice(item.id)"
         
              >设备</el-button
            > -->
            <el-button
              size="mini"
              type="primary"
              @click.stop="showDevice(item.id)"
              v-if="item.is_tester == 1 && item.state >= 3 && item.state <= 5"
              >设备</el-button
            >
            <el-button
              size="mini"
              type="danger"
              @click.stop="chexiaoTask(item.id)"
              v-if="checkRole(1) && item.state == 1"
              >撤销</el-button
            >
            <el-button
              size="mini"
              type="default"
              @click.stop="editTask(item.id)"
              v-if="checkRole(1) && item.state < 1"
              >编辑</el-button
            >
            <el-button
              size="mini"
              @click.stop="fuyongTask(item.id)"
              v-if="checkRole(1)"
              >复用</el-button
            >
            <el-button
              size="mini"
              type="danger"
              @click.stop="tuihuiTask(item.id)"
              v-if="checkRole(3) && (item.state == 2 || item.state == 3)"
              >退回</el-button
            >
            <el-button
              size="mini"
              type="danger"
              @click.stop="delTask(item.id)"
              v-if="checkRole(1) && item.state < 1"
              >删除</el-button
            >
          </div>
        </el-row>
      </div>

      <div
        style="
          font-size: 14px;
          width: 35%;
          margin: 0 auto;
          margin-top: 20px;
          background: #c1d8f5;
          line-height: 35px;
          border-radius: 3px;
          color: #666;
        "
        v-if="search.isover == false"
        v-on:click="loadNext"
      >
        加载更多
      </div>
    </div>

    <div class="flowBtn" v-if="checkRole(1)">
      <el-button size="normal" type="primary" @click="addTask"
        >添加任务</el-button
      >
    </div>
    <div class="flowBtn" v-if="checkRole(4)">
      <el-button size="normal" type="primary" @click="batchPaiche"
        >批量派车</el-button
      >
    </div>
    <el-dialog title="审核任务" :visible.sync="dialog.taskPass" width="90%">
      <TaskPass
        ref="taskPass"
        @onPassed="
          dialog.taskPass = false;
          reSearch();
        "
      ></TaskPass>
    </el-dialog>
    <el-dialog title="分配人员" :visible.sync="dialog.taskAllocate" width="90%">
      <TaskAllocate
        ref="taskAllocate"
        @onSuccess="
          dialog.taskAllocate = false;
          reSearch();
        "
      ></TaskAllocate>
    </el-dialog>
    <el-dialog title="分配车辆" :visible.sync="dialog.taskSetCar" width="90%">
      <TaskSetCar
        ref="taskSetCar"
        @onSuccess="
          dialog.taskSetCar = false;
          reSearch();
        "
      ></TaskSetCar>
    </el-dialog>
    <el-dialog
      title="携带设备"
      :visible.sync="dialog.taskSetDevice"
      :close-on-click-modal="false"
      width="90%"
    >
      <TaskSetDevice
        ref="taskSetDevice"
        @onSuccess="dialog.taskSetDevice = false"
      ></TaskSetDevice>
    </el-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/header.vue";
import TaskPass from "@/views/dialog/task_pass.vue";
import TaskAllocate from "@/views/dialog/task_allocate.vue";
import TaskSetCar from "@/views/dialog/task_setcar.vue";
import TaskSetDevice from "@/views/dialog/task_setdevice.vue";

export default {
  name: "index",
  components: {
    Header,
    TaskPass,
    TaskAllocate,
    TaskSetCar,
    TaskSetDevice,
  },
  data() {
    return {
      lguser: { name: "", role: 0 },
      statelist: [
        { id: 0, text: "待提交" },
        { id: 1, text: "待审核" },
        { id: 2, text: "待分配" },
        { id: 3, text: "待派车" },
        { id: 4, text: "待检测" },
        { id: 5, text: "检测中" },
        { id: 6, text: "已完成" },
        { id: 7, text: "已评价" },
        { id: -1, text: "审核不通过" },
      ],
      searchStateList: [],
      search: {
        state: "",
        word: "",
        gotime: "",
        page: 0,
        limit: 20,
        isover: false,
      },
      list: [],
      datacount: 0,
      dialog: {
        taskPass: false,
        taskAllocate: false,
        taskSetCar: false,
        taskSetDevice: false,
      },
    };
  },
  mounted() {
    this.lguser = JSON.parse(localStorage.getItem("uinfo"));
    this.judgeStateList();
    this.reSearch();
  },
  methods: {
    judgeStateList() {
      var userRoles = [];
      if (this.lguser.roles) {
        userRoles = this.lguser.roles;
      } else {
        userRoles.push(this.lguser.role);
      }
      var that = this;
      userRoles.forEach((role) => {
        switch (role) {
          case 1:
            that.search.state = "";
            that.searchStateList = that.statelist;
            break;
          case 2:
            that.search.state = 1;
            that.searchStateList.push({ id: 1, text: "待审核" });
            break;
          case 3:
            that.search.state = 2;
            that.searchStateList.push({ id: 2, text: "待分配" });
            break;
          case 4:
            that.search.state = 3;
            that.searchStateList.push({ id: 3, text: "待派车" });
            break;
          case 5:
            that.search.state = 4;
            that.searchStateList.push({ id: 4, text: "待检测" });
            that.searchStateList.push({ id: 5, text: "检测中" });
            that.searchStateList.push({ id: 6, text: "已完成" });
            that.searchStateList.push({ id: 7, text: "已评价" });
            break;
          case 7:
            that.searchStateList = that.statelist;
            break;
        }
      });
    },
    //检查是否有权限
    checkRole(role1, role2) {
      if (role2 != undefined) {
        //检查一个范围
        if (this.lguser.roles) {
          for (var i = role1; i <= role2; i++) {
            if (this.lguser.roles.indexOf(i) < 0) {
              return false;
            }
          }
        } else {
          return this.lguser.role >= role1 && this.lguser.role <= role2;
        }
      } else {
        if (role1 instanceof Array) {
          for (var i = 0; i < role1.length; i++) {
            if (this.lguser.roles) {
              return this.lguser.roles.indexOf(role1[i]) >= 0;
            } else {
              if (this.lguser.role == role1[i]) {
                return true;
              }
            }
          }
          return false;
        } else {
          if (this.lguser.roles) {
            return this.lguser.roles.indexOf(role1) >= 0;
          } else {
            return this.lguser.role == role1;
          }
        }
      }
    },
    reSearch() {
      this.search.page = 0;
      this.search.isover = false;

      this.loadNext();
    },
    async loadNext() {
      var data = await this.$api.request.get("/task/pager_list", {
        params: this.search,
      });
      this.datacount = data.count;
      data = data.list;
      data.forEach((element) => {
        element.checked = false;
      });
      if (this.search.page == 0) {
        this.list = [];
      }
      var _list = this.list;
      this.list = _list.concat(data);
      if (data.length < this.search.limit) {
        this.search.isover = true;
      } else {
        this.search.page++;
      }
    },
    viewDetail(item, judgeDirver) {
      if (judgeDirver) {
        //需要判断 司机登录
        if (!this.checkRole(4)) {
          this.$router.push("/task_info?id=" + item.id);
        }
      } else {
        this.$router.push("/task_info?id=" + item.id);
      }
    },
    editTask(id) {
      this.$router.push("/task_add?id=" + id);
    },
    fuyongTask(id) {
      this.$router.push("/task_add?fuyongid=" + id);
    },
    addTask() {
      this.$router.push("/task_add");
    },
    testTask(item) {
      this.$router.push("/task_make?id=" + item.id);
    },
    getStateText(state, substate) {
      for (var i = 0; i < this.statelist.length; i++) {
        if (this.statelist[i].id == state) {
          if (state == 3) {
            if (substate == 1) {
              return "私车审批中";
            } else {
              return "待派车";
            }
          } else {
            return this.statelist[i].text;
          }
        }
      }
    },
    getStateColor(state) {
      switch (state) {
        case -1:
          return "danger";
        case 1:
          return "danger";
        case 2:
          return "danger";
        case 3:
          return "danger";
        case 4:
          return "";
        case 5:
          return "";
        case 6:
          return "success";
        case 7:
          return "success";
      }
      return "";
    },
    async chexiaoTask(id) {
      await this.$api.confirm("确认撤销此任务吗？");
      var data = await this.$api.request.post("/task/chexiao", {
        id: id,
      });
      this.$api.success("撤销成功");
      this.reSearch();
    },
    async delTask(id) {
      await this.$api.confirm("确认删除此任务吗？");
      var data = await this.$api.request.post("/task/delete", {
        id: id,
      });
      this.$api.success("删除成功");
      this.reSearch();
    },
    async tuihuiTask(id) {
      await this.$api.confirm("确认退回此任务到业务经理吗？");
      var data = await this.$api.request.post("/task/tuihui", {
        id: id,
      });
      this.$api.success("退回成功");
      this.reSearch();
    },
    async passPrivateCar(id) {
      await this.$api.confirm("确认审批通过吗？");
      var data = await this.$api.request.post("/task/pass_privatecar", {
        taskid: id,
      });
      this.$api.success("批准成功");
      this.reSearch();
    },
    showDevice(id) {
      this.dialog.taskSetDevice = true;
      this.$nextTick(() => {
        this.$refs.taskSetDevice.showInfo(id);
      });
    },
    showPass(id) {
      this.dialog.taskPass = true;
      this.$nextTick(() => {
        this.$refs.taskPass.showInfo(id);
      });
    },
    allocateTask(id) {
      this.dialog.taskAllocate = true;
      this.$nextTick(() => {
        this.$refs.taskAllocate.showInfo(id);
      });
    },
    setCarForTask(id) {
      this.dialog.taskSetCar = true;
      this.$nextTick(() => {
        this.$refs.taskSetCar.showInfo(id);
      });
    },
    batchPaiche() {
      var chkids = this.list.filter((f) => f.checked).map((f) => f.id);
      if (chkids.length == 0) {
        this.$api.error("请选择任务");
        return;
      }
      var id = chkids.join(",");
      this.dialog.taskSetCar = true;
      this.$nextTick(() => {
        this.$refs.taskSetCar.showInfo(id);
      });
    },
  },
};
</script>
<style scoped>
.datalist {
  padding-bottom: 140px;
  min-height: 70vh;
}
.datalist .item {
  padding-bottom: 20px;
  border-bottom: 1px solid #eee;
  width: 90%;
  margin: 0 auto;
  margin-top: 10px;
  padding: 10px 3%;
  background: #fff;
  border-radius: 3px;
}
.flowBtn {
  position: fixed;
  bottom: 5vh;
  left: 0;
  width: 100%;
  text-align: center;
}
.serno {
  font-style: normal;
  color: #999;
  font-size: 13px;
}
</style>
